import { isbot } from "isbot";

import * as logger from "./logger";

// Automated clients (crawlers, headless browsers, scraper fleets) execute our
// analytics bundles and inflate per-event billing without producing usable
// insights, so we skip initialization for them entirely.

// Real Firefox never carries a Safari-style "Version/x" token; UAs with both
// are fabricated by scraper UA generators.
const FORGED_UA_PATTERN = /Version\/[\d.]+.*Firefox\//;

export const isLikelyAutomated = (): boolean => {
  // Non-browser environment: nothing worth tracking
  if (typeof navigator === "undefined") {
    return true;
  }

  // Set by WebDriver-based automation (Puppeteer, Playwright, Selenium)
  // even when the user agent has been disguised
  if (navigator.webdriver) {
    return true;
  }

  try {
    const userAgent = navigator.userAgent ?? "";
    return isbot(userAgent) || FORGED_UA_PATTERN.test(userAgent);
  } catch (e) {
    logger.error("Bot detection failed, failing closed", e);
    return true;
  }
};
